import { useEffect, useState } from 'react';

export default function useLoadAppsFlyer() {
  const [isLoaded, setIsLoaded] = useState(
    () => typeof window !== 'undefined' && typeof window.AF_SMART_SCRIPT !== 'undefined'
  );

  useEffect(() => {
    function onLoad() {
      setIsLoaded(true);
    }

    let script: HTMLScriptElement;

    function loadAppsFlyer() {
      const src = 'https://cdn-assets.alltrails.com/assets/onelink-smart-script-latest.js';

      const existing = document.querySelector(`script[src="${src}"]`) as HTMLScriptElement | null;

      if (!existing) {
        script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.addEventListener('load', onLoad);
        document.body.appendChild(script);
      } else {
        if (typeof window.AF_SMART_SCRIPT !== 'undefined') {
          // Script already loaded, update state immediately
          setIsLoaded(true);
        } else {
          // Script exists but hasn't loaded yet, attach listener to existing tag
          existing.addEventListener('load', onLoad);
          script = existing;
        }
      }
    }

    if (typeof window.AF_SMART_SCRIPT === 'undefined') {
      loadAppsFlyer();
    } else {
      setIsLoaded(true);
    }

    return () => {
      if (script) {
        script.removeEventListener('load', onLoad);
      }
    };
  }, []);

  return isLoaded;
}
